var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"item7a111060-3e05-11ec-a2e6-953464dcce14"}},[_c('div',{attrs:{"id":"titleBox"}},[_c('h3',[_vm._v("组织形式数量占比")]),_c('div',{staticClass:"boderBottom"})]),_c('div',{attrs:{"id":"topRightRingEchart4"}})])
}]

export { render, staticRenderFns }